import { Component, OnInit } from '@angular/core'

@Component({
    selector: './warranties',
    templateUrl: './warranties.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class WarrantiesComponent implements OnInit {

    ngOnInit() {

    }
}